jQuery(document).ready(function($){
	
	//product detail button for toggle
	jQuery('.button-biografie').on('click', function(){
		jQuery(this).toggleClass("close");
		jQuery('.biografie').toggleClass("open");
	});

});